import axios from 'axios';
import { StoreState } from "./store";
let store: StoreState;
export const injectStore = (_store: any) => store = _store;

export const axiosClient = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL
});

axiosClient.interceptors.request.use(async (config: any) => {
    // Se ejecuta antes de realizar la request
    return config;
}, (error) => {
    return Promise.reject(error);
});

axiosClient.interceptors.response.use(
    (response: any) => {
        return response;
    }, 
    async (error: any) => {
        return Promise.reject(error);
    }
);